export const ORDER_QUERY_KEY = "order";
export const MANY_COMPANIES_THRESHOLD = 7;

export type OrderStatus = "action-required" | "created";
